module.exports = __webpack_public_path__ + "img/03-2-1KPI.a1cf1e6b.svg";